export default __webpack_public_path__ + "e1a0e15a0bea47ef8d8463befdc6e3b2.png";